import ScalarTeleport_vue_vue_type_script_setup_true_lang_default from "./ScalarTeleport.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarTeleport/ScalarTeleport.vue
var ScalarTeleport_default = ScalarTeleport_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarTeleport_default as default };

//# sourceMappingURL=ScalarTeleport.vue.js.map